export * from './DetailsPageDescription';
